var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 34,
    viewBox: "0 0 60 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 32,
    rx: 16,
    fill: "none",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8817 26.999L21.1446 26.999C20.996 27.0039 20.848 26.9781 20.7094 26.9231C20.5707 26.8682 20.4443 26.7852 20.3375 26.6792C20.2307 26.5731 20.1458 26.4461 20.0879 26.3057C20.0299 26.1653 20 26.0144 20 25.8619C20 25.7094 20.0299 25.5585 20.0879 25.4181C20.1458 25.2777 20.2307 25.1507 20.3375 25.0446C20.4443 24.9385 20.5707 24.8556 20.7094 24.8006C20.848 24.7457 20.996 24.7199 21.1446 24.7248L38.8817 24.7248C39.0302 24.7199 39.1782 24.7457 39.3169 24.8006C39.4555 24.8556 39.582 24.9386 39.6887 25.0446C39.7955 25.1507 39.8804 25.2777 39.9384 25.4181C39.9964 25.5585 40.0262 25.7094 40.0262 25.8619C40.0262 26.0144 39.9964 26.1653 39.9384 26.3057C39.8804 26.4461 39.7955 26.5731 39.6887 26.6792C39.582 26.7852 39.4555 26.8682 39.3169 26.9231C39.1782 26.9781 39.0302 27.0039 38.8817 26.999Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9303 14.9613L27.7972 14.9613L27.7972 8.13777C27.797 7.98853 27.8255 7.84071 27.8811 7.70277C27.9366 7.56483 28.0181 7.43946 28.1208 7.33382C28.2236 7.22818 28.3456 7.14434 28.48 7.08708C28.6143 7.02983 28.7583 7.00028 28.9038 7.00012L31.1205 7.00012C31.2662 6.99997 31.4104 7.02929 31.5451 7.08641C31.6797 7.14352 31.802 7.22732 31.905 7.33299C32.008 7.43866 32.0897 7.56413 32.1453 7.70223C32.201 7.84032 32.2296 7.98833 32.2294 8.13777L32.2294 14.9613L35.0964 14.9613C35.3158 14.9612 35.5303 15.0279 35.7127 15.1529C35.8952 15.2779 36.0374 15.4556 36.1214 15.6635C36.2053 15.8715 36.2273 16.1003 36.1845 16.321C36.1416 16.5418 36.0359 16.7446 35.8807 16.9037L30.7971 22.1178C30.5888 22.3307 30.3068 22.4503 30.0127 22.4503C29.7187 22.4503 29.4366 22.3307 29.2283 22.1178L24.1459 16.9037C23.9907 16.7445 23.885 16.5418 23.8421 16.321C23.7993 16.1003 23.8213 15.8715 23.9052 15.6635C23.9892 15.4556 24.1314 15.2779 24.3139 15.1529C24.4963 15.0279 24.7108 14.9612 24.9303 14.9613Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadQrIcon);
export default __webpack_public_path__ + "static/media/download-qr-icon.a7febf32.svg";
export { ForwardRef as ReactComponent };